import FilterDaysBy from './FilterDaysBy';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { setApplicationFilterDaysBy } from 'store/reducers/userInteractions/actions';

// Reducers
import { getFilterDaysBy } from 'store/reducers/userInteractions/selectors';

const mapStateToProps = state => {
  return {
    filterDaysBy: getFilterDaysBy(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setApplicationFilterDaysBy }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterDaysBy);



// WEBPACK FOOTER //
// ./src/components/molecules/FilterDaysBy/FilterDaysByContainer.js